export const ROUTES = {
  home: "/",
  about: "/about",
  commissions: "/commissions",
  portfolio: "/portfolio",
  portfolioDetail: (slug: string) => `/portfolio/${slug}`,
  partners: "/partners",
  references: "/references",
  contact: "/contact",
  socials: "/socials",
  terms: "/terms",
  privacy: "/privacy",
  termsOfUse: "/terms-of-use",
  disclaimer: "/disclaimer",
  admin: {
    login: "/admin/login",
    root: "/admin",
    about: "/admin/about",
    portfolio: "/admin/portfolio",
    portfolioCategories: "/admin/portfolio/categories",
    partners: "/admin/partners",
    references: "/admin/references",
    commissions: "/admin/commissions",
    contactSubmissions: "/admin/contact-submissions",
    legal: "/admin/legal",
    media: "/admin/media",
    socials: "/admin/socials",
    settings: "/admin/settings",
    users: "/admin/users",
    profile: "/admin/profile",
  },
} as const;
